import React, { Fragment } from 'react';
export function Marquee() {
  const items = ['STRATEGY', 'BRANDING', 'SOCIAL', 'CONTENT', 'WEB', 'STRATEGY', 'BRANDING', 'SOCIAL', 'CONTENT', 'WEB'];
  return <div className="bg-brand-black text-brand-white border-y-2 border-brand-black py-[22px] overflow-hidden" data-id="element-80" data-mp="2ikp4x51hjinw">
      <div className="flex gap-[60px] animate-marquee whitespace-nowrap pl-[60px]" data-id="element-81" data-mp="2dm5lbbad6iyp">
        {items.map((item, i) => <Fragment key={i} data-id="element-82" data-mp="3b68m038rrcas" data-mpi={i}>
            <span className="font-black text-[clamp(2rem,5vw,3.6rem)] tracking-[0.01em] uppercase" data-id="element-83" data-mp="369hxcriwf8dr">
              {item}
            </span>
            <span className="text-brand-accent font-black text-[clamp(2rem,5vw,3.6rem)]" data-id="element-84" data-mp="318u5k3muinih">
              ●
            </span>
          </Fragment>)}
      </div>
    </div>;
}